import React, { useEffect, useState } from 'react';

import { Layer, Source, useMap } from 'react-map-gl';
import { useSelector } from 'react-redux';

export const MapLayers = () => {
  const {mymap} = useMap();

  const layerConf = useSelector(state => state.layerConf);

  const [buttonsLayersState, setButtonsLayersState] = useState(layerConf.buttonsLayersState);
  const [layerList, setLayerList] = useState(layerConf.layers);
  const [sourceList, setSourceList] = useState(layerConf.sources);
  const [update, setUpdate] = useState(0);

  const handleVisibilityLayer = () => {
    let map = mymap.getMap();
    for (const key in buttonsLayersState) {
      buttonsLayersState[key].layersName.forEach(function (layer) {
        if (map.getLayer(layer) !== undefined && map.getLayer !== null) {
          map.setLayoutProperty(layer, 'visibility', buttonsLayersState[key].active === true ? 'visible': 'none');
        }
      });
    }
  };

  useEffect(() => {
    /**
     * handle visibility of layers when there is changes from selection of layers
     */
    if (mymap !== undefined && mymap !== null && update > 0) {
      handleVisibilityLayer();
    }
  }, [update]);

  useEffect(() => {
    setButtonsLayersState(layerConf.buttonsLayersState);
    setLayerList(layerConf.layers);
    setSourceList(layerConf.sources);
    setUpdate(update + 1);
    /**
       * Passer l'instance de map vers l'objet Window 
       * utilisé par les tests Cypress
       */
    window.layerInfo = mymap;

  }, [layerConf]);

  useEffect(() => {
    /**
     * handle visibility of layers when there is changes in responsive
     */
    if (mymap !== undefined && mymap !== null) {
      mymap.getMap().once('idle', () => {
        handleVisibilityLayer();
      });
    }
  }, [mymap]);

  return (
    <>
      {Object.entries(sourceList).map(([id, source]) => {
        return (
          <Source key={id} id={id} type={source.type} tiles={source.tiles} minzoom={10} attribution={source.attribution} />
        );
      })}
      { layerList.map((layer) => {
        return <Layer key={layer.id} id={layer.id} {...layer} />;
      }
      )}
      
    </>
  );
};
